module.exports = __webpack_public_path__ + "img/picture.8427edf7.svg";